<up-top-header />

<bt-sidenav></bt-sidenav>
<div class="padding-small shift-right">
  <bt-topbar></bt-topbar>
  <router-outlet></router-outlet>
</div>
